import * as Api_version_bs$SolvuuApi0 from "./api_version_bs.bs.js";
import * as Api_version_atd$SolvuuApi0 from "./api_version_atd.bs.js";

function to_string(param) {
  return "0";
}

var Json = Api_version_bs$SolvuuApi0;
var json_of_t = Api_version_atd$SolvuuApi0.json_of_t;
var t_of_json = Api_version_atd$SolvuuApi0.t_of_json;
export { Json, json_of_t, t_of_json, to_string };
/* Api_version_bs-SolvuuApi0 Not a pure module */